import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import actions from './actions';
import {deleto, get, patch, post, puto} from 'bukku/shared/ApiService';
import {errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn} from "../helper";
import {t} from "@lingui/macro";

const successKeys = [
    actions.LOCATION_CREATE_SUCCESS,
    actions.LOCATION_CREATE_SUCCESS,
    actions.LOCATION_IMPORT_SUCCESS,
    actions.LOCATION_READ_SUCCESS,
    actions.LOCATION_READ_ALL_SUCCESS,
    actions.LOCATION_UPDATE_SUCCESS,
    actions.LOCATION_ARCHIVE_SUCCESS,
    actions.LOCATION_DELETE_SUCCESS,
];
const errorKeys = [
    actions.LOCATION_CREATE_ERROR,
    actions.LOCATION_CREATE_ERROR,
    actions.LOCATION_IMPORT_ERROR,
    actions.LOCATION_READ_ERROR,
    actions.LOCATION_READ_ALL_ERROR,
    actions.LOCATION_UPDATE_ERROR,
    actions.LOCATION_ARCHIVE_ERROR,
    actions.LOCATION_DELETE_ERROR,
];

const getSuccessMsg = action => {
    const { data, location } = action;
    switch (action.type) {
        case actions.LOCATION_CREATE_SUCCESS:
            return t`The location is created.`;
        case actions.LOCATION_UPDATE_SUCCESS:
            return t`The location is updated.`;
        case actions.LOCATION_DELETE_SUCCESS:
            return t`The location is deleted.`;
        case action.LOCATION_IMPORT_SUCCESS:
            return t`%${data.created_count} locations created and ${data.updated_count} locations updated.`;
        case action.LOCATION_ARCHIVE_SUCCESS:
            return location.is_archived ? t`The location is deactivated.` : t`The location is activated.`;
        default:
            return null;
    }
};

// Create location
function* createLocationRequest() {
    yield takeEvery(actions.LOCATION_CREATE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({request}) {
                const response = yield call(post, '/locations', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.LOCATION_CREATE_SUCCESS,
                    locationo: data.location,
                });
            });
    });
}

// Import location
function* importLocationsRequest() {
    yield takeEvery(actions.LOCATION_IMPORT_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({request}) {
                const response = yield call(post, '/locations/batch', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.LOCATION_IMPORT_SUCCESS,
                    data,
                });
            });
    });
}

// Read location list
function* readLocationsRequest() {
    yield takeEvery(actions.LOCATION_READ_ALL_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({request}) {
                const response = yield call(get, '/locations', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.LOCATION_READ_ALL_SUCCESS,
                    locations: data.locations,
                    pagination: data.paging,
                });
            });
    });
}

// Read location (by id)
function* readLocationRequest() {
    yield takeEvery(actions.LOCATION_READ_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                const response = yield call(get, `/locations/${id}`, null, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.LOCATION_READ_SUCCESS,
                    locationo: data.location,
                });
            });
    });
}

// Update location (by id)
function* updateLocationRequest() {
    yield takeEvery(actions.LOCATION_UPDATE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                const response = yield call(puto, `/locations/${id}`, request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.LOCATION_UPDATE_SUCCESS,
                    locationo: data.location,
                });
            });
    });
}

// Archive location (by id)
function* archiveLocationRequest() {
    yield takeEvery(actions.LOCATION_ARCHIVE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                const response = yield call(patch, `/locations/${id}`, request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.LOCATION_ARCHIVE_SUCCESS,
                    locationo: data.location,
                });
            });
    });
}

// Archive location (by id)
function* deleteLocationRequest() {
    yield takeEvery(actions.LOCATION_DELETE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id }) {
                yield call(deleto, `/locations/${id}`, null, context);
                yield put({ type: actions.LOCATION_DELETE_SUCCESS });
            });
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(createLocationRequest),
        fork(importLocationsRequest),
        fork(readLocationsRequest),
        fork(readLocationRequest),
        fork(updateLocationRequest),
        fork(archiveLocationRequest),
        fork(deleteLocationRequest),
    ]);
}
